import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  tabIndex: -1,
  prevTabIndex: null,
  arrowIndex: 0,
  showTabItems: false,
  selectedMobileItem: null,
  tabs: [],
  navButtonsCurrent: null,
  navButtonsNew: null,
  selfCareData: null,
  showSelfCareMenu: false,
  userData: null,
  navItemIndex: -1,
  showMenu: false,
  animate: '',
  mouseInHeader: false,
  hideNavigation: false,
};

const headerBlockSlice = createSlice({
  name: 'headerBlock',
  initialState: initialState,
  reducers: {
    setTabIndex: (state, action) => {
      //replace current history state with current tab index and reset navItemIndex
      console.debug(`[HeaderBlockSlice] window.history.replaceState pathname:${window.location.pathname} ,navItemIndex: -1  `);
      window.history.replaceState(
        {
          ...window.history.state,
          tabIndex: action.payload,
          pathname: window.location.pathname,
          navItemIndex: -1,
        },
        '',
        window.location.pathname + window.location.search + window.location.hash,
      );
      state.tabIndex = action.payload;
      state.navItemIndex = -1; // Reset navItemIndex
    },
    setArrowIndex: (state, action) => {
      state.arrowIndex = action.payload;
    },
    setShowTabItems: (state, action) => {
      state.showTabItems = action.payload;
    },
    setSelectedMobileItem: (state, action) => {
      state.showTabItems = action.payload;
    },
    setTabs: (state, action) => {
      state.tabs = action.payload;
    },
    setIndex: (state, action) => {
      state.index = action.payload;
    },
    setNavButtonsCurrent: (state, action) => {
      state.navButtonsCurrent = action.payload;
    },
    setNavButtonsNew: (state, action) => {
      state.navButtonsNew = action.payload;
    },
    setSelfCareData: (state, action) => {
      state.selfCareData = action.payload;
    },
    setShowSelfCareMenu: (state, action) => {
      state.showSelfCareMenu = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setNavItemIndex: (state, action) => {
      //replace current history state with current nav item index
      console.debug(
        `[HeaderBlockSlice] window.history.replaceState pathname:${window.location.pathname} ,navItemIndex: ${action.payload}  `,
      );
      window.history.replaceState(
        {
          ...window.history.state,
          navItemIndex: action.payload,
          pathname: window.location.pathname,
        },
        '',
        window.location.pathname + window.location.search + window.location.hash,
      );
      state.navItemIndex = action.payload;
    },
    setShowMenu: (state, action) => {
      state.showMenu = action.payload;
    },
    setAnimate: (state, action) => {
      state.animate = action.payload;
    },
    toggleTabButton: (state, action) => {
      if (state.showTabItems === true) {
        state.arrowIndex = action.payload;
      } else if (state.showTabItems === false) {
        state.arrowIndex = action.payload;
      }
      state.showTabItems = !state.showTabItems;
    },
    setState: (state, action) => {
      state = action.payload;
      state.showTabItems = false;
    },
    isBusinessNavigationMode: (state) => {
      return state.tabs[state.tabIndex]?.isBusinessTab?.value === true;
    },
    setHideNavigation: (state, action) => {
      state.hideNavigation = action.payload;
    },
  },
});

export const {
  setTabIndex,
  setArrowIndex,
  setShowTabItems,
  setSelectedMobileItem,
  setTabs,
  setIndex,
  setNavButtonsCurrent,
  setNavButtonsNew,
  setSelfCareData,
  setShowSelfCareMenu,
  setUserData,
  setShowMenu,
  setAnimate,
  toggleTabButton,
  toggleMouseInHeader,
  setNavItemIndex,
  setState,
  setHideNavigation,
} = headerBlockSlice.actions;

export default headerBlockSlice.reducer;
